import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=18326131&scoped=true&"
import script from "./Home.ts?vue&type=script&lang=ts&"
export * from "./Home.ts?vue&type=script&lang=ts&"
import style0 from "./home.scss?vue&type=style&index=0&id=18326131&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18326131",
  null
  
)

export default component.exports